export const isGiftOptions = t => [
  { label: t('Sí'), value: 'true' },
  { label: t('No'), value: 'false' },
]
